import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Login from './pages/Login';
import Redirect from './pages/Redirect';
import './App.css';
import Main from './pages/Main';
import ProtectedRoute from './components/ProtectedRoute';
import CreateMap from './pages/CreateMap';
import Overview from './pages/Overview';
import ViewMap from './pages/ViewMap';
import TokenOverview from './pages/TokenOverview';
import MapImageOverview from './pages/MapImageOverview';
import SpectateMap from './pages/SpectateMap';


function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route element={<ProtectedRoute />} >
                    <Route path="main" element={<Main />}>
                        <Route path="" element={<Overview />} />
                        <Route path="tokens" element={<TokenOverview />} />
                        <Route path="map-images" element={<MapImageOverview />} />
                        <Route path="create" element={<CreateMap />} />
                        <Route path="view/:id" element={<ViewMap />} />
                        {(
                            <Route path="spectate" element={<SpectateMap />} />
                        )}
                    </Route>
                </Route>
                <Route path="redirect" element={<Redirect />} />
                <Route path ="/" element={<Login />} />
            </Routes>
        </BrowserRouter>
    );
}

export default App;
